import ShareClipboard from "./ShareClipboard";
import type { ShareClipboardDataType } from "./shareClipboardHelpers";
import { isValidShareClipboardPayload } from "./shareClipboardHelpers";
import useShareClipboard from "./useShareClipboard";

export { isValidShareClipboardPayload, useShareClipboard };
export type { ShareClipboardDataType };
export default ShareClipboard;
